import { render, staticRenderFns } from "./collectionCode-product.vue?vue&type=template&id=0bef32e8&"
import script from "./collectionCode-product.vue?vue&type=script&lang=ts&"
export * from "./collectionCode-product.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports